module.exports = __webpack_public_path__ + "static/circles-32e8916f251f0b4fb0b45425cd62085c.png";